import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useGetDropdownValues = keyName => {
  const [values, setValues] = useState([]);

  useEffect(() => {
    if (!keyName) return;

    const fetchData = async () => {
      if (keyName === 'product') {
        try {
          const res = await customAxios.get('/Ops/GetProducts', { headers: authHeader() });
          const products = res.data.map(item => ({
            label: item.productName,
          }));
          setValues(products);
          return;
        } catch (err) {
          console.log(err);
        }
      }

      try {
        // 🔹 Special case: Drivers (from /User/GetAllUsers)
        if (keyName === 'driver') {
          const res = await customAxios.get('/User/GetAllUsers', { headers: authHeader() });

          if (res?.data && Array.isArray(res.data)) {
            // Return both name and email for each user
            const driverList = res.data
              .filter(item => item.isDriver === 1)
              .map(user => ({
                label: user.displayName || '',
                email: user.email || '',
              }));

            const loaderList = res.data
              .filter(item => item.isLoader === 1)
              .map(user => ({ label: user.displayName || '', email: user.email || '' }));

            console.log(driverList, loaderList, 'listData');

            setValues({ driverList, loaderList });
          } else {
            setValues([]);
          }
          return;
        }

        if (keyName == 'Customers') {
          const res = await customAxios.get('/CRM/GetCustomerLocations', { headers: authHeader() });

          if (res.data) {
            const customerList = res.data.map(customer => ({
              label: customer.destinationName,
            }));
            setValues(customerList);
          } else {
            setValues([]);
          }
          return;
        }

        // 🔹 Generic dropdown API for other keyNames
        const res = await customAxios.post('/GenTasks/GetDropdownListArray', [keyName], {
          headers: authHeader(),
        });

        if (res.status === 200 && Array.isArray(res.data)) {
          const match = res.data.find(item => item.keyName?.toLowerCase() === keyName.toLowerCase());
          // Keep structure consistent — always an array of { label }
          const formatted = match?.values?.map(v => (typeof v === 'string' ? { label: v } : v)) || [];
          setValues(formatted);
        } else {
          setValues([]);
        }
      } catch (err) {
        console.error(`Failed to fetch dropdown values for ${keyName}:`, err);
        setValues([]);
      }
    };

    fetchData();
  }, [keyName]);

  return values;
};

export default useGetDropdownValues;
